import { Box, Card } from '@mui/material'

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import WTypography from 'Components/whiteTypography'
import { Bar, Line } from 'react-chartjs-2'
// import { Line } from 'react-chartjs-2'
import moment from 'moment'
import 'moment/locale/fr'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function SuiviDuTemps({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const navigate = useNavigate()

  const optionsbar = {
    indexAxis: 'x',
    responsive: true,
    aspectRatio: 1,

    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        position: 'bottom',
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
          title: () => null,
        },
      },
    },
    scales: {
      x: {
        stacked: false,
        ticks: {
          color: 'white',

          callback: function (e) {
            // console.log(moment(data.labels[e]).format('MMM'))
            return moment(data.labels[e]).format('MMM')
          },
        },
      },
      y: {
        stacked: false,
        ticks: { color: 'white' },
      },
    },
  }
  const color = [
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
  ]
  const [data, setRevData] = useState({
    labels: ['2022', '2023', '2024', '2025'],
    datasets: [
      {
        label: 'Administratif',
        data: [1, 2, 2.5, 6],
        backgroundColor: ['#60829b'],
        borderColor: ['#60829b'],
        barThickness: 10,
      },
      {
        label: 'Finance',
        data: [2, 2, 2.5, 6],
        backgroundColor: ['#60839b'],
        borderColor: ['#60839b'],
        barThickness: 10,
      },
    ],
  })
  useEffect(() => {
    let dataset = []
    let labels = []
    oldData[0]['label'].forEach((e, indx) => {
      let data = []
      oldData[0]['data'].forEach((el, elindx) => {
        data.push(el['data'][indx])
      })
      dataset.push({
        label: e,
        data: data,
        backgroundColor: color[indx],
        borderColor: color[indx],
        barThickness: 10,
      })
    })
    oldData[0]['data'].forEach((e, indx) => {
      labels.push(e['label'])
    })
    // oldData[0]['data'].forEach((e, indx) => {
    //   dataset.push({
    //     label: e['label'],
    //     data: e['data'],
    //     backgroundColor: color[indx],
    //     borderColor: color[indx],
    //     barThickness: 10,
    //   })
    // })
    // console.log(dataset)
    // console.log({ labels: labels, datasets: dataset })
    setRevData({ labels: labels, datasets: dataset })
  }, [oldData])
  const HorizontalBarChart = () => (
    <>
      <Line data={data} height={560} options={optionsbar} />
    </>
  )
  return (
    <>
      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1">
          <WTypography component={'span'} variant="h6">
            {t('syntheseTemps.timeTrackingTitle')}
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {t('syntheseTemps.timeTrackingSubtitle')}
          </WTypography>
        </Box>

        <Box minWidth={3} mb={6} height={'100%'} className="no-drag">
          <HorizontalBarChart />
        </Box>
      </Card>
    </>
  )
}

export default SuiviDuTemps
